import { render, staticRenderFns } from "./LinkNewServiceModal.vue?vue&type=template&id=385aa139&scoped=true&"
import script from "./LinkNewServiceModal.vue?vue&type=script&lang=js&"
export * from "./LinkNewServiceModal.vue?vue&type=script&lang=js&"
import style0 from "./LinkNewServiceModal.vue?vue&type=style&index=0&id=385aa139&scoped=true&lang=css&"
import style1 from "./LinkNewServiceModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385aa139",
  null
  
)

export default component.exports